import { render, staticRenderFns } from "./yi_curd_table.vue?vue&type=template&id=ae6cef28&scoped=true&"
import script from "./yi_curd_table.vue?vue&type=script&lang=js&"
export * from "./yi_curd_table.vue?vue&type=script&lang=js&"
import style0 from "./yi_curd_table.vue?vue&type=style&index=0&id=ae6cef28&lang=scss&scoped=true&"
import style1 from "./yi_curd_table.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6cef28",
  null
  
)

export default component.exports